<IziGrid>
  <IziCol>
    <IziCard class="game-card">
      <IziGrid padding="10px">
        <IziCol class="game-card-image" padding="5px 20px 0px 20px">
          <img v-if="game.imageUrl" :src="game.imageUrl" :alt="game.image" />
          <img v-else src="../../assets/img/challenge.jpg" :alt="game.image" />
          <span class="time">{{game.length}} minutes</span>
        </IziCol>
        <IziCol class="game-card-title">
          <span>{{ game.name }}</span>
        </IziCol>
        <IziCol class="game-card-description">
          <span>{{ game.description }}</span>
        </IziCol>
        <iziCol class="game-card-avatar" col="6">
          <div class="avatar">
            <Avatar :src="game.creator.photoURL" />
          </div>
          <div class="infor">
            <span>{{game.creator.displayName}}</span>
          </div>
        </iziCol>
        <IziCol class="game-card-info" col="6">
          <div class="infor">
            <IziIcon>local_fire_department</IziIcon>
            <span>1,030</span>
          </div>
        </IziCol>
      </IziGrid>
    </IziCard>
  </IziCol>
</IziGrid>